import { minOneIntegerRule, positiveDecimal3Rule, requiredInputRule, } from "@erp/shared/utils/form/rules";
export const registLaborInputs = [
    {
        label: "품번",
        key: "no",
        col: "12",
        sm: "6",
        lg: "6",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "공종",
        key: "name",
        col: "12",
        sm: "6",
        lg: "6",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "규격",
        key: "type",
        col: "12",
        sm: "6",
        lg: "6",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "직종",
        key: "occupation",
        type: "select",
        value: "",
        list: [],
        col: "12",
        sm: "6",
        lg: "6",
        rules: [requiredInputRule],
    },
    {
        label: "공량(M/D)",
        key: "manPerDay",
        type: "number",
        col: "12",
        sm: "6",
        lg: "6",
        value: 0,
        min: 0,
        step: 0.1,
        rules: [positiveDecimal3Rule],
    },
    {
        label: "할증율",
        key: "surchargeRatio",
        type: "percent",
        col: "12",
        sm: "6",
        lg: "6",
        min: 0,
        step: 0.1,
        value: 0,
        rules: [positiveDecimal3Rule],
    },
];
export const laborCostCalcHeaders = [
    { text: "품번", align: "start", value: "no" },
    { text: "공종", align: "start", value: "name" },
    { text: "규격", align: "start", value: "type" },
    { text: "직종", align: "start", value: "occupation" },
    { text: "공량(M/D)", align: "start", value: "manPerDay" },
    { text: "할증율", align: "start", value: "surchargeRatio" },
    { text: "편집", align: "center", value: "actions" },
];
export const registMarketWageUnitPriceInputs = [
    {
        label: "직종",
        key: "occupation",
        value: "",
        col: "12",
        sm: "6",
        lg: "6",
        rules: [requiredInputRule],
    },
    {
        label: "단가",
        key: "unitPrice",
        type: "number",
        col: "12",
        sm: "6",
        lg: "6",
        value: 0,
        min: 0,
        step: 10000,
        rules: [minOneIntegerRule],
    },
    {
        label: "설계 조정율",
        key: "adjustmentRatio",
        type: "number",
        col: "12",
        sm: "6",
        lg: "6",
        min: 0,
        max: 1,
        step: 0.1,
        value: 0,
        rules: [positiveDecimal3Rule],
    },
];
export const marketWageUnitPriceHeaders = [
    { text: "직종", align: "start", value: "occupation" },
    { text: "단가", align: "start", value: "unitPrice" },
    { text: "설계 조정률", align: "start", value: "adjustmentRatio" },
    { text: "편집", align: "center", value: "actions" },
];
export const registOutputRatioInputs = [
    {
        label: "종류",
        key: "type",
        value: "",
        col: "12",
        sm: "12",
        lg: "12",
        rules: [],
    },
    {
        label: "계산식",
        key: "formula",
        col: "12",
        sm: "6",
        lg: "6",
        value: "",
        clearable: false,
        rules: [],
    },
    {
        label: "비율",
        key: "ratio",
        type: "percent",
        col: "12",
        sm: "6",
        lg: "6",
        value: 0,
        suffix: "%",
        min: 0,
        step: 0.1,
        rules: [],
    },
];
export const outputRatioHeaders = [
    { text: "종류", align: "start", value: "type" },
    { text: "계산식", align: "start", value: "formula" },
    { text: "편집", align: "center", value: "actions" },
];
